// extracted by mini-css-extract-plugin
module.exports = {"image":"gokada-module--image--130zi","content":"gokada-module--content--2LNcz"};